import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Listings } from 'containers/AppContainer/typings';
import { PROCEDURE_STEPS } from 'containers/data-structure';
import { get, isEmpty, isNil, isUndefined } from 'lodash';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/messages';
import { translate } from 'containers/services/translate';
import { EXPERTISE_FIELD } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/constants';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import FormsByExpertiseType from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType';
import {
  ExpertReportType,
  IExpertGlobalReportState,
  IVehiculeExpertise,
  IVictimExpertise,
} from 'containers/common/LegalProceedings/ExpertReport/typings';
import ExpertiseVictim from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/Expertise/Victim';
import ExpertiseVehicule from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/Expertise/Vehicule';
import { BUTTON_COLORS } from 'constants/design';
import {
  isExpertiseRejected,
  manageDeactivationButton,
  showUpdateButton,
  showValidateButton,
} from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/utils';
import { Box } from '@material-ui/core';
import { shouldShowBox } from 'containers/common/LegalProceedings/ExpertReportAppeal/utils';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { useExpertReportValidation } from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/hooks';
import { TYPE } from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/constants';
import {
  LEGAL_PROCEEDINGS_STEPS,
  PROCEDURE_TYPES,
} from 'containers/LawyerLegalProceedingsPage/constants';
import { mergeEvaluations } from 'containers/CourtManagerLegalProceedings/ExpertReport/utils';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import {
  STATUS_PENDING,
  STATUS_REJECTED,
} from 'containers/LawyerFeeNote/constants';
import { Claim } from 'containers/PreOpeningPage/typings';
import { getExpertiseSagisEvaluation } from 'containers/CourtManagerLegalProceedings/ExpertReport/utils';
import { resolveSagisClaim } from 'helpers/utils';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/constants';
import moment from 'moment-timezone';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import {
  getResponsibilityShareByExpertise,
  renderExpertiseData,
  resolveSagisInfo,
} from 'containers/common/LegalProceedings/ExpertReport/utils';
import ValidationDialog from 'containers/common/LegalProceedings/ExpertReport/ValidationDialog';
import { useSelector } from 'react-redux';
import { priorityClaimReason } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { VictimType } from 'typings/globalTypes';

export interface ExpertiseByTypeProps {
  intl: IntlShape;
  expertReportState: IExpertGlobalReportState[];
  listings: Listings;
  uploadDocument?: Function;
  uploadedDocument?: IUploadedDocument;
  resetUploadedDocument?: Function;
  documentId?: string;
  setDocumentId?: Function;
  readOnly?: boolean;
  isManager?: boolean;
  expertReport: ExpertReportType;
  setIsDecisionDialgOpen?: Function;
  setExpertReportState: Function;
  isDecisionDialgOpen?: boolean;
  validateVictimExpertise?: any;
  isAssignedLawyer: boolean;
  isCreator?: boolean;
  deactivateButton?: any;
  setDeactivateButton?: Function;
  judgementAddDocuments?: any;
  setIsSuccessPopinOpen?: Function;
  expertise: any;
  item: any;
  index: number;
  documentIndex: number;
  expertiseIndex: number;
  expertiseType: string;
  currentExpertise: any;
  requestCreateExpertiseRaport?: Function;
  requestGetExpertiseRaport?: Function;
  requestValidateExpertReport?: Function;
  claimId: number;
  judiciaryProcessId?: number;
  claimNumber?: string;
  isAppeal: boolean;
  isRecap?: boolean;
  assignedLawyers?: string[];
  victims?: VictimType[];
  claim?: Claim;
  policyInfo?: any;
  hasJom?: boolean;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  isBasicManagement?: boolean;
  imagineDocuments: any;
  expertiseRaportFirstInstance: any;
  dahirAmount?: any;
  requestGetDocByDocumentumId: Function;
}

export const ExpertiseByType: React.FC<ExpertiseByTypeProps> = (
  props,
): JSX.Element => {
  const [openDialogValidation, setOpenDialogValidation] = useState(false);
  const setExpertise = (
    documentIndex: number,
    expertiseIndex: number,
    victimIndex?: number,
    vehiculeIndex?: number,
  ) => (expertiseField: IVictimExpertise | IVehiculeExpertise) => {
    const expertReport = [...props.expertReportState];

    const expertise = expertReport[documentIndex].expertises[expertiseIndex];

    if (!isNil(victimIndex)) {
      expertise.victims[victimIndex] = expertiseField as IVictimExpertise;
    }

    if (!isNil(vehiculeIndex)) {
      expertise.vehicules[vehiculeIndex] = expertiseField as IVehiculeExpertise;
    }

    props.setExpertReportState(expertReport);
  };
  const isExpertReportValidated = useExpertReportValidation(
    props.currentExpertise,
    props.expertiseType,
  );
  const renderByExpertiseTypeContainer = (
    expertiseId: string,
    expertiseJudgementAddDocumentId: string,
    expertise: IVictimExpertise | IVehiculeExpertise,
    expertReportIndexes: {
      documentIndex: number;
      expertiseIndex: number;
      victimIndex?: number;
      vehiculeIndex?: number;
    },
  ) => {
    const {
      documentIndex,
      expertiseIndex,
      victimIndex,
      vehiculeIndex,
    } = expertReportIndexes;

    const index = !isUndefined(victimIndex) ? victimIndex : vehiculeIndex;

    return (
      <FormsByExpertiseType
        listings={props.listings}
        victimExpertise={expertise as IVictimExpertise}
        vehiculeExpertise={expertise as IVehiculeExpertise}
        expertiseJudgementAddDocumentId={expertiseJudgementAddDocumentId}
        expertiseId={String(expertiseId)}
        setExpertise={setExpertise(
          documentIndex,
          expertiseIndex,
          victimIndex,
          vehiculeIndex,
        )}
        uploadDocument={props.uploadDocument as Function}
        uploadedDocument={props.uploadedDocument as IUploadedDocument}
        resetUploadedDocument={props.resetUploadedDocument as Function}
        documentId={props.documentId as string}
        setDocumentId={props.setDocumentId as Function}
        documentIndex={index as number}
        readOnly={props.readOnly}
        isManager={props.isManager}
        setIsDecisionDialgOpen={props.setIsDecisionDialgOpen}
        isDecisionDialgOpen={props.isDecisionDialgOpen}
        validateVictimExpertise={props.validateVictimExpertise}
        isRejected={get(props.currentExpertise, 'status') === STATUS_REJECTED}
        isAppeal={props.isAppeal}
        isAssignedLawyer={props.isAssignedLawyer}
        isRecap={props.isRecap}
        isExpertReportValidated={isExpertReportValidated}
        username={get(lawyerInfo, 'username')}
        isLawyerAssignedJudiciary={
          props.assignedLawyers
            ? props.assignedLawyers.includes(get(lawyerInfo, 'sagisCode', ''))
            : false
        }
        expertReport={props.expertReport}
        policyInfo={props.policyInfo}
        imagineDocuments={props.imagineDocuments}
        claimId={props.claimId}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
      />
    );
  };
  const handleCreateExpertReport = (toUpdate: boolean) => () => {
    !toUpdate &&
      manageDeactivationButton(
        props.expertiseType,
        props.deactivateButton,
        props.currentExpertise,
        props.setDeactivateButton,
      );
    const RiskKey = get(
      resolveSagisClaim(props.policyInfo),
      'offeredRisks',
      [],
    ).find((element: { riskName: string }) => element.riskName === rcCoporeal)
      ?.riskId;

    const provisionBody = {
      riskID: RiskKey,
      date: moment().toISOString(true),
    };
    const sagisEvaluations = mergeEvaluations(
      getExpertiseSagisEvaluation(
        props.expertReport,
        [props.currentExpertise],
        props.victims,
        props.claim,
        props.expertiseRaportFirstInstance,
        props.dahirAmount,
      ),
    );

    const allVictimExpertise =
      !isEmpty(get(props.expertReport, 'victimExpertises', [])) &&
      !isEmpty(props.currentExpertise)
        ? [
            ...get(props.expertReport, 'victimExpertises', []).filter(
              (el: any) => el.id != get(props.currentExpertise, 'id'),
            ),
            ...[props.currentExpertise],
          ]
        : [];

    !isExpertiseRejected(props.currentExpertise) && !toUpdate
      ? props.requestCreateExpertiseRaport &&
        props.requestCreateExpertiseRaport(
          {
            isLawyer: !props.isManager,
            isInboxesActive: featureService.hasFeature(
              FEATURES.ATTRIBUTION_INBOXES_MANAGER,
            ),
            isTrackingActive: featureService.hasFeature(
              FEATURES.TRACKING_ACTIONS_USER,
            ),
            sagisEvaluations:
              props.isManager && get(props.currentExpertise, 'victimId')
                ? sagisEvaluations
                : undefined,
            provisionBody:
              props.isManager && get(props.currentExpertise, 'victimId')
                ? provisionBody
                : undefined,
            victimExpertise:
              props.expertiseType === TYPE.VICTIM ? props.currentExpertise : {},
            vehiculeExpertise:
              props.expertiseType === TYPE.VEHICLE
                ? props.currentExpertise
                : {},
            id: props.expertReport ? get(props.expertReport, 'id') : undefined,
            claimId: props.claimId,
            claimNumber: props.claimNumber,
            procedureType: props.isAppeal
              ? PROCEDURE_TYPES.APPEAL
              : PROCEDURE_TYPES.FIRST_INSTANCE,
            ...(!get(props.expertReport, 'id')
              ? {
                  step: LEGAL_PROCEEDINGS_STEPS.EXPERT_REPORT,
                  status: '',
                }
              : undefined),
            judiciaryProcessId: props.judiciaryProcessId,
            priorityClaimReasonId:
              featureService.hasFeature(FEATURES.PRIORITY_CLAIM) &&
              priorityReasonClaimId !== 4
                ? priorityClaimReason(
                    sagisEvaluations,
                    !isEmpty(
                      get(
                        resolveSagisClaim(props.policyInfo),
                        'offeredRisks',
                        [],
                      ),
                    )
                      ? get(
                          resolveSagisClaim(props.policyInfo),
                          'offeredRisks',
                          [],
                        )
                          .map((el: any) => Number(el.riskProvisions))
                          .reduce(
                            (accumulator: any, currentValue: any) =>
                              accumulator + currentValue,
                          )
                      : 0,
                    props.listings,
                  )
                : undefined,
          },
          successCallback(toUpdate),
          handleError,
        )
      : props.requestValidateExpertReport &&
        props.requestValidateExpertReport(
          {
            expertReport: {
              victimExpertises:
                props.expertiseType === TYPE.VICTIM
                  ? [
                      {
                        ...props.currentExpertise,
                        consultancyReportDocument: toUpdate
                          ? {}
                          : get(
                              props.currentExpertise,
                              'consultancyReportDocument',
                              {},
                            ),
                        toUpdate,
                        status: !props.isManager
                          ? STATUS_PENDING
                          : get(props.currentExpertise, 'status'),
                        rejectionReason: null,
                      },
                    ]
                  : [],
              vehiculeExpertises:
                props.expertiseType === TYPE.VEHICLE
                  ? [
                      {
                        ...props.currentExpertise,
                        consultancyReportDocument: toUpdate
                          ? {}
                          : get(
                              props.currentExpertise,
                              'consultancyReportDocument',
                              {},
                            ),
                        toUpdate,
                        status: !props.isManager
                          ? STATUS_PENDING
                          : get(props.currentExpertise, 'status'),
                        rejectionReason: null,
                      },
                    ]
                  : [],
            },
            sagisEvaluations: resolveSagisInfo(
              toUpdate,
              props.isManager,
              props.currentExpertise,
            )
              ? sagisEvaluations
              : undefined,
            provisionBody: resolveSagisInfo(
              toUpdate,
              props.isManager,
              props.currentExpertise,
            )
              ? provisionBody
              : undefined,
            toUpdate,
            step: PROCEDURE_STEPS.EXPERT_REPORT,
            isLawyer: !props.isManager,
            claimNumber: props.claimNumber,
            procedureType: props.isAppeal
              ? PROCEDURE_TYPES.APPEAL
              : PROCEDURE_TYPES.FIRST_INSTANCE,
            judiciaryProcessId: get(props.expertReport, 'judiciaryProcessId'),
            claimId: props.claimId,
            isInboxesActive: featureService.hasFeature(
              FEATURES.ATTRIBUTION_INBOXES_MANAGER,
            ),
            isTrackingActive: featureService.hasFeature(
              FEATURES.TRACKING_ACTIONS_USER,
            ),
            isPriorityActive: featureService.hasFeature(
              FEATURES.PRIORITY_CLAIM,
            ),
            priorityClaimReasonId:
              featureService.hasFeature(FEATURES.PRIORITY_CLAIM) &&
              priorityReasonClaimId !== 4
                ? priorityClaimReason(
                    sagisEvaluations,
                    !isEmpty(
                      get(
                        resolveSagisClaim(props.policyInfo),
                        'offeredRisks',
                        [],
                      ),
                    )
                      ? get(
                          resolveSagisClaim(props.policyInfo),
                          'offeredRisks',
                          [],
                        )
                          .map((el: any) => Number(el.riskProvisions))
                          .reduce(
                            (accumulator: any, currentValue: any) =>
                              accumulator + currentValue,
                          )
                      : 0,
                    props.listings,
                    allVictimExpertise,
                  )
                : undefined,
          },
          successCallback(toUpdate),
        );
  };

  const successCallback = (toUpdate: boolean) => () => {
    isEmpty(get(props.expertReport, 'id', '')) &&
      props.requestGetExpertiseRaport &&
      props.requestGetExpertiseRaport(
        props.claimId,
        props.isAppeal
          ? PROCEDURE_TYPES.APPEAL
          : PROCEDURE_TYPES.FIRST_INSTANCE,
        props.judiciaryProcessId,
      );
    props.setIsSuccessPopinOpen && props.setIsSuccessPopinOpen(true);
    toUpdate && setOpenDialogValidation(false);
  };
  const handleError = () => {
    props.setDeactivateButton &&
      manageDeactivationButton(
        props.expertiseType,
        props.deactivateButton,
        props.currentExpertise,
        props.setDeactivateButton,
      );
  };
  const lawyerInfo = {
    username: currentIntervenantStorage.get()?.preferred_username,
    sagisCode: currentIntervenantStorage.get()?.sagis_code,
  };

  const priorityReasonClaimId = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'priorityReasonId']),
  );
  return (
    <Box
      className={shouldShowBox(props.expertise) ? 'box-field' : ''}
      key={props.index}
    >
      <div className="expertise-item">
        {props.expertiseType === TYPE.VEHICLE && (
          <ExpertiseVehicule
            key={props.item.id}
            vehicule={props.item}
            sagisOpposingParties={props.sagisOpposingParties}
            isBasicManagement={props.isBasicManagement}
          >
            {renderByExpertiseTypeContainer(
              props.expertise[EXPERTISE_FIELD.EXPERTISE_ID],
              props.expertise[
                EXPERTISE_FIELD.EXPERTISE_JUDGEMENT_ADD_DOCUMENT_ID
              ] as string,
              props.item,
              {
                documentIndex: props.documentIndex,
                expertiseIndex: props.expertiseIndex,
                victimIndex: undefined,
                vehiculeIndex: props.index,
              },
            )}
          </ExpertiseVehicule>
        )}
        {props.expertiseType === TYPE.VICTIM && (
          <ExpertiseVictim
            key={props.item.id}
            victim={props.item}
            sagisVictimInfo={props.sagisVictimInfo}
            isBasicManagement={props.isBasicManagement}
          >
            {renderByExpertiseTypeContainer(
              props.expertise[EXPERTISE_FIELD.EXPERTISE_ID],
              props.expertise[
                EXPERTISE_FIELD.EXPERTISE_JUDGEMENT_ADD_DOCUMENT_ID
              ] as string,
              props.item,
              {
                documentIndex: props.documentIndex,
                expertiseIndex: props.expertiseIndex,
                victimIndex: props.index,
              },
            )}
          </ExpertiseVictim>
        )}

        {showValidateButton(
          props.currentExpertise,
          props.judgementAddDocuments,
          props.expertReport,
          props.deactivateButton,
          props.expertiseType,
          lawyerInfo,
          props.isCreator,
          props.assignedLawyers,
          props.isManager || false,
        ) && (
          <PrimaryButton
            title={translate(messages.validate, props)}
            background={BUTTON_COLORS.PRIMARY_BLUE}
            border={BUTTON_COLORS.PRIMARY_BLUE}
            titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
            onClick={handleCreateExpertReport(false)}
            className="validate"
            disabled={!isExpertReportValidated}
          />
        )}
        {showUpdateButton(
          props.expertReport,
          props.expertiseType,
          props.currentExpertise,
          props.isManager,
        ) &&
          get(
            renderExpertiseData(
              get(props.expertReport, 'victimExpertises'),
              get(props.expertReport, 'vehiculeExpertises'),
              props.item,
            ),
            'status',
          ) !== STATUS_PENDING && (
            <PrimaryButton
              title={translate(messages.update, props)}
              background={BUTTON_COLORS.PRIMARY_BLUE}
              border={BUTTON_COLORS.PRIMARY_BLUE}
              titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
              onClick={() =>
                props.hasJom
                  ? setOpenDialogValidation(true)
                  : handleCreateExpertReport(true)()
              }
            />
          )}

        {getResponsibilityShareByExpertise(
          props.expertise[EXPERTISE_FIELD.EXPERTISE_JUDGEMENT_ADD_DOCUMENT_ID],
          props.judgementAddDocuments,
        ) &&
          props.isManager && (
            <span
              style={{
                marginBottom: '10px',
                width: '100%',
                color: 'red',
              }}
            >
              {translate(messages.responsibilityShareWarning, props)}
            </span>
          )}
        {featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) && (
          <ValidationDialog
            open={openDialogValidation}
            handleClose={() => setOpenDialogValidation(false)}
            handleValidate={handleCreateExpertReport(true)}
            expertiseType={props.expertiseType}
          />
        )}
      </div>
    </Box>
  );
};

export default injectIntl(ExpertiseByType);
